import * as React from 'react';
import { DescriptiveCard, ImagePosition, BUTTON_TYPE } from '@bepure/tarkin';
import { renderPrePurchaseButton } from './PrePurchaseButton';
import * as ReactDOM from 'react-dom';
import * as htmlEntities from 'html-entities';

const HTMLEntities = htmlEntities.AllHtmlEntities;

interface Props {
    id: string;
    card: {
        imageRight: string;
        image: string;
        header: string;
        description: string;
        buttonText?: string;
        buttonLink?: string;
    };
}

const render = (props: Props) => {
    const element = document.getElementById(props.id);
    if (element) {
        const buttonText = props.card.buttonText || undefined;
        const buttonLink = props.card.buttonLink || undefined;
        const button = buttonText !== undefined && buttonLink !== undefined ? renderPrePurchaseButton(BUTTON_TYPE.PRIMARY, buttonText, '', buttonLink) : undefined;
        const children = <div dangerouslySetInnerHTML={innerHTML(props.card.description)}/>;
        const component = (
            <DescriptiveCard
                imagePosition={props.card.imageRight === 'True' ? ImagePosition.AFTER : ImagePosition.BEFORE}
                image={props.card.image}
                header={props.card.header}
                button={button}
                verticalCenterText={!button}
            >
                {children}
            </DescriptiveCard>
        );
        ReactDOM.render(component, element);
    }
};

function innerHTML(text: string) {
    const entities = new HTMLEntities();
    const decoded = entities.decode(entities.decode(text)); // decoded twice due to & being encoded after initial encoding
    return {__html: decoded};
}

export default render;
